module.exports = __webpack_public_path__ + "static/media/Master-1.f84f2d00.webp";